import { useScreenSize } from '@hooks';

export const onboardingPageLayoutByVariant = {
  desktop: {
    height: 560,
    pl: 156,
    pr: 156,
    px: 156,
  },
  laptop: {
    height: 560,
    pl: 24,
    pr: 24,
    px: 24,
  },
  mobile: {
    height: 500,
    pl: 16,
    pr: 16,
    px: 16,
  },
  tablet: {
    height: 560,
    pl: 24,
    pr: 24,
    px: 24,
  },
};

export const useTextVariant = ({ currentSlide }) => {
  const { isLaptop, isMobile, isTabletSM } = useScreenSize();
  const isTitle = currentSlide === 0;

  if (!isTitle) {
    return isTabletSM ? 'MS-regular-s18-lh28' : 'MS-regular-s26-lh40';
  }

  if (isMobile) return 'BN-bold-s28-lh25';

  return isLaptop ? 'BN-bold-s44-lh44' : 'BN-bold-s56-lh67';
};
